import React from 'react'
import { Button, Icon } from '../../../shared'
import { AlertIcon } from '../alert-icon.component';

interface IFavouriteTagErrorModalProps {
  callback: () => void
}

export const FavouriteTagErrorModal = ({ callback }: IFavouriteTagErrorModalProps): JSX.Element => {
  return (
    <div style={{ textAlign: 'center', padding: '30px', backgroundColor: 'rgba(203, 5, 0, 0.1)' }}>
      <AlertIcon />
      <h3 style={{ fontSize: '24px', lineHeight: '38px', textTransform: 'uppercase' }}>Sorry!</h3>
      <p style={{ fontSize: '18px', lineHeight: '24px' }}>Our system is currently having trouble processing your request,<br/>so we can't change your Favourite Order right now.
Please try again later.</p>
      <Button onClick={callback}>OK</Button>
    </div>
  )
}
